import React from 'react'
import AdminPanel from '../../Components/AdminUsers/AdminPanel'


const Search = () => {
  return (
    <AdminPanel/>
  )
}

export default Search